import { Link } from '@packages/modules/src/Link/Link';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import {
  Accordion,
  AccordionDetails,
  AccordionItem,
  AccordionSummary,
} from '@packages/shared/src/ui/Accordion/Accordion';
import type { JSX } from 'react';
import { useIntl } from 'react-intl';
import { useAssignLinkTargetBasedOnBotStatus } from '../../../hooks/useAssignLinkTargetBasedOnBotStatus';
import { classes } from '../../../utils/classes';
import { messages } from '../PromotionBanner.messages';
import { PromotionBannerTestIds } from '../PromotionBannerTestIds';

export const PromotionAccordionTemplate = ({
  summaryContent,
  toggleFunction,
  detailscontent,
  defaultExpanded,
  isPaybackPromotion,
}: {
  summaryContent: string;
  toggleFunction?: () => void;
  detailscontent: JSX.Element;
  defaultExpanded?: boolean;
  isPaybackPromotion?: boolean;
}) => {
  const { formatMessage } = useIntl();
  const config = useConfig();
  const assignLinkTarget = useAssignLinkTargetBasedOnBotStatus();
  const finalLink = assignLinkTarget(formatMessage(messages.newsletterSubscribeLink));

  return (
    <Accordion
      // INSPIRE-3604 - use transparent background to prevent sharp edges cover rounded
      // edges the uppermost wrapper defines the color
      type="single"
      defaultValue={defaultExpanded ? 'promotion-accordion' : undefined}
      onValueChange={toggleFunction}
      collapsible
      key="promotion-accordion"
    >
      <AccordionItem
        value="promotion-accordion"
        className="bg-color-transparent before:bg-color-transparent mb-0! shadow-none"
        key="promotion-accordion-item"
      >
        <AccordionSummary
          className={classes(
            config.styleVariant === 'dark' ? 'font-bold' : 'justify-center',
            isPaybackPromotion
              ? '[&>span]:bg-color-text-light'
              : '[&>span]:bg-color-primary-contrasttext',
          )}
          icon="icon-emp-arrow-medium-down"
          key="promotion-accordion-summary"
        >
          <span data-testid={PromotionBannerTestIds.title}>{summaryContent}</span>
        </AccordionSummary>
        <AccordionDetails data-testid={PromotionBannerTestIds.content}>
          {detailscontent}
          <div
            className={classes(
              'border-t-color-primary-contrasttext mt-3.5 flex items-center gap-2 border-t pt-2',
              config.styleVariant === 'dark' ? 'flex-row' : 'flex-col',
            )}
          >
            <span className="icon-emp-mail h-4 w-4" />
            <Link
              className="text-size-body2 hover:underline"
              href={finalLink}
              color="inherit"
              onClick={toggleFunction}
            >
              {formatMessage(messages.newsletterTeaserText)}
            </Link>
          </div>
        </AccordionDetails>
      </AccordionItem>
    </Accordion>
  );
};
